export default __webpack_public_path__ + "img/1_12-6b7d7c6d.png";